import Service from '../../../components/Systema/Service';
import config from '../../../config';

const service = new Service(`${config.api_path}/v1/estrutura-organizacional`);

export default service;
